export default "__VITE_ASSET__Dj8yHz2u__"